/** @module csi/image/ImageEditorPluginMixin */
define([
	"dojo/_base/declare"
], function(declare) {
	return declare(null, {
		/** @property {Object} widget - Image Editor */
		widget: null,

		postCreate: function() {
			this.widget = this.getView();
			this.inherited(arguments);
		}
	});
});